import React from 'react';
import { CheckBadgeIcon } from '@heroicons/react/24/solid';

/** Badge « Entreprise suivie » du porteur (PRD lot 7), calculé par la base. */
const BadgeEntrepriseSuivie = () => (
  <span
    className="inline-flex items-center gap-1 rounded-full bg-emerald-50 text-emerald-800 border border-emerald-200 px-2 py-0.5 text-xs font-semibold"
    title="Cette entreprise note ses ventes et ses dépenses régulièrement depuis plus de trois mois sur Innovactive360°."
  >
    <CheckBadgeIcon className="w-3.5 h-3.5" aria-hidden="true" />
    Entreprise suivie
  </span>
);

export default BadgeEntrepriseSuivie;
